import {
  computed,
  Injectable,
  resource,
  ResourceLoaderParams,
  ResourceRef,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { DEFAULT_ORDERS, IParsedOrder, IParsedOrders } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { firstValueFrom } from 'rxjs';
import { UserOrdersGateway } from './user-orders.gateway';

@Injectable({
  providedIn: 'root',
})
export class UserOrdersStore {
  private readonly gateway: UserOrdersGateway = new UserOrdersGateway();
  private readonly userId: WritableSignal<string> = signal('');

  #ordersResource: ResourceRef<IApiResponse<IParsedOrders> | undefined> =
    resource({
      params: this.userId,
      loader: ({
        params,
      }: ResourceLoaderParams<string>): Promise<
        IApiResponse<IParsedOrders>
      > => {
        return firstValueFrom(this.gateway.get(params));
      },
    });

  readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#ordersResource.isLoading()
  );
  readonly orders: Signal<IParsedOrders> = computed(
    (): IParsedOrders =>
      this.#ordersResource.hasValue()
        ? (this.#ordersResource.value()?.data ?? DEFAULT_ORDERS)
        : DEFAULT_ORDERS
  );

  readonly allUserOrders: Signal<IParsedOrder[]> = computed(() => {
    const orders: IParsedOrders = this.orders();
    return orders.activeOrders.concat(orders.archivedOrders);
  });

  getOrders(userId: string): void {
    this.userId.set(userId);
  }

  reloadOrders(): void {
    this.#ordersResource.reload();
  }
}
